<template>
  <div>
    <div class="cup-grid">
      <button class="cup-btn" v-for="cup of cups" :key="cup" :class="{'current' : cup == current}" @click="$emit('getCup', cup)">
        <img :src="`/cups/${cup}.png`" :alt="cup">
      </button>

      <button class="cancel" @click="$emit('cancelCup')">Nevermind. Cancel.</button>
    </div>
  </div>
</template>


<script>
export default {
  name:"CupPicker",
  props:{
    current: String
  },
  data() {
    return {
      cups:['cup', 'red-cup', 'orange-cup', 'green-cup', 'pink-cup', 'purple-cup', 'sparkle-cup', 'sans-cup'],
      preFetched: []
    }
  },
  mounted() {
    this.checkCache();
  },
  methods: {
    checkCache(){
      const self = this;
      this.cups.forEach((cup) => {
        if(!self.preFetched.includes(cup)){
          fetch(`/cups/${cup}.png`)
          .then(() => self.preFetched.push(cup))
        }
      })
    }
  },
}
</script>


<style lang="scss">
  .cup-grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1em;

    .cup-btn{
      width: 100%;
      border: 2px solid transparent;
      background: none;
      box-shadow: none;
      transition: all 250ms;

      &.current{
        background: #42b983;
      }

      &:hover{
        border-color: #000;
      }

      img{
        max-width: 100%;
      }
    }

    .cancel{
      grid-column: span 2;
    }
  }
</style>